import { Registration } from '@stax-core/types-omni';
import { USD } from '../../../util/currency.util';

const dataCompromisedFields: Partial<Registration['pci_compromise_type']>[] = [
  'NOTIFY_ACTION_DONE',
  'NOTIFY_ACTION_NOT_STARTED',
];

const mpaCNPMapper = (registration: Registration) => {
  return {
    iso_webhosting:
      registration.meta?.mpaCardNotPresent?.internetBusinessType ===
      'webHosting',
    iso_domainreg:
      registration.meta?.mpaCardNotPresent?.internetBusinessType ===
      'domainRegistration',
    iso_webpagedesign:
      registration.meta?.mpaCardNotPresent?.internetBusinessType ===
      'webPageDesign',
    iso_auction:
      registration.meta?.mpaCardNotPresent?.internetBusinessType === 'auction',
    iso_internetservicegateway:
      registration.meta?.mpaCardNotPresent?.internetBusinessType ===
      'internetServiceGateway',
    iso_digitalservice:
      registration.meta?.mpaCardNotPresent?.internetBusinessType ===
      'digitalService',
    iso_advertisement:
      registration.meta?.mpaCardNotPresent?.internetBusinessType ===
      'advertisement',
    iso_hardgoods:
      registration.meta?.mpaCardNotPresent?.internetBusinessType ===
      'hardGoods',
    iso_transactioninformation:
      registration.meta?.mpaCardNotPresent?.transactionInformation || '',
    iso_marketingmaterial:
      registration.meta?.mpaCardNotPresent?.advertProcess || '',
    iso_monthly_billing:
      Number.parseInt(
        registration.meta?.mpaCardNotPresent?.billing?.monthly || '0',
      ) > 0,
    iso_monthly_percentage:
      registration.meta?.mpaCardNotPresent?.billing?.monthly || '',
    iso_yearly_billing:
      Number.parseInt(
        registration.meta?.mpaCardNotPresent?.billing?.annually || '0',
      ) > 0,
    iso_yearly_percentage:
      registration.meta?.mpaCardNotPresent?.billing?.annually || '',
    iso_quarterly_billing:
      Number.parseInt(
        registration.meta?.mpaCardNotPresent?.billing?.quarterly || '0',
      ) > 0,
    iso_quarterly_percentage:
      registration.meta?.mpaCardNotPresent?.billing?.quarterly || '',
    iso_onetime_billing:
      Number.parseInt(
        registration.meta?.mpaCardNotPresent?.billing?.oneTime || '0',
      ) > 0,
    iso_onetime_percentage:
      registration.meta?.mpaCardNotPresent?.billing?.oneTime || '',
    iso_hourly_billing:
      Number.parseInt(
        registration.meta?.mpaCardNotPresent?.billing?.hourly || '0',
      ) > 0,
    iso_hourly_percentage:
      registration.meta?.mpaCardNotPresent?.billing?.hourly || '',
    iso_vendor: `${registration?.meta?.mpaCardNotPresent?.vendorName || ''} ${
      registration?.meta?.mpaCardNotPresent?.vendorAddress || ''
    }`,
    iso_fulfillment:
      registration.meta?.mpaCardNotPresent?.fulfillmentPerformer || '',
    iso_orderlifecycle:
      registration.meta?.mpaCardNotPresent?.orderDescription || '',
    min_monthly: registration.monthly_minimum_fee ?? '',
    monthly_service: registration.monthly_service_fee ?? '',
    datacompromise_no: registration.pci_compromise_type === 'NOT_NOTIFY',
    datacompromise_yes: dataCompromisedFields.includes(
      registration.pci_compromise_type,
    ),
    completedremediation_no:
      registration.pci_compromise_type === 'NOTIFY_ACTION_NOT_STARTED',
    completedremediation_yes:
      registration.pci_compromise_type === 'NOTIFY_ACTION_DONE',
    mastercardvisa_volume:
      USD.parse(registration.annual_volume || '0')
        ?.multiply(0.9)
        .format() || '',
    discovernetwork_paypal_volume:
      USD.parse(registration.annual_volume || '0')
        ?.multiply(0.05)
        .format() || '',
    amexoptblue_volume:
      USD.parse(registration.annual_volume || '0')
        ?.multiply(0.05)
        .format() || '',
  };
};

export const fisPriorityCombinedMapper = (r: Registration) => {
  return mpaCNPMapper(r);
};
